import { businessStatus } from './../../common/function';
import { HttpContext } from '@angular/common/http';
import { quietRead, QUIET_HTTP_ERRORS } from 'src/app/common/background-request';
import { IMAGE_SKELETON_PIXEL } from 'src/app/shared/Directives/business-image.directive';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  NgbDateParserFormatter,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';
import KeenSlider, { KeenSliderInstance, KeenSliderPlugin } from 'keen-slider';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ToastrService } from 'ngx-toastr';
import { distinctUntilChanged, map, Observable, Subscription, zip, timeout, timer, filter } from 'rxjs';
import {
  Function,
  businessHours,
  tooltipTriggers,
} from 'src/app/common/function';
import { toInstagramUrl, toTelUrl, toTwitterUrl, toWebsiteUrl } from 'src/app/common/contact-links';
import { directionsUrl } from 'src/app/common/directions';
import { GOOGLE_MAP_ID } from 'src/app/common/google-maps-config';
import { isRestaurantImageProfileUrl, restaurantImageUrl } from 'src/app/common/restaurant-image-url';
import { CropResult, GalleryImageModel } from 'src/app/models/gallery-image-model';
import { KeyNameModel, KeyTitleModel } from 'src/app/models/key-value-model';
import { Business, BusinessMenu, MembershipBranchImageType } from 'src/app/models/register-business';
import { BusinessService } from 'src/app/services/business.service';
import { LoaderService } from 'src/app/services/loader.service';
import { PageTitleService } from 'src/app/services/page-title.service';
import { UserService } from 'src/app/services/user.service';
import { WhatsOnService } from 'src/app/services/whats-on.service';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { environment } from '../../../environments/environment';
import { TourService } from 'src/app/tour/tour.service';

@Component({
  selector: 'app-business-detail',
  templateUrl: './business-detail.component.html',
  styleUrls: ['./business-detail.component.scss'],
  // encapsulation: ViewEncapsulation.None,
})
export class BusinessDetailComponent implements OnInit {
  model!: NgbDateStruct;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  selectedProduct: BusinessMenu;
  selectedIndex: number | null = null;
  private tourDataLoaded = false;
  private tourLoadFailed = false;
  private tourPhotoInteracted = false;
  private readonly viewSubscriptions = new Subscription();
  private tourStepTimer?: ReturnType<typeof setTimeout>;
  private readonly loadedTourImages = new Set<string>();
  private readonly failedTourImages = new Set<string>();
  private tourMenuElement?: HTMLElement;
  detailLoading = true;
  detailError = false;
  photosLoading = true;
  photosError = false;
  menuLoading = true;
  menuError = false;
  reviewsLoading = true;
  reviewsError = false;
  mapsReady = false;
  mapsError = false;
  private mapsSubscription?: Subscription;
  private readonly requestTimeout = 15000;
  private restaurantSubscriptions = new Subscription();
  private readonly croppedImageUrls = new Set<string>();
  private readonly preparedPhotoCategories = new Set<number>();
  private readonly requestedGalleryImages = new Set<string>();
  private readonly preparedGalleryCrops = new Set<string>();
  private readonly failedGalleryProfiles = new Set<string>();
  private readonly failedThumbnailProfiles = new Set<string>();
  private galleryImageIndices: Record<number, number> = {};
  private routeGeneration = 0;
  private destroyed = false;
  private readonly quietContext = new HttpContext().set(QUIET_HTTP_ERRORS, true);
  private recoveryAfter = 0;
  constructor(
    private ngbDateParserFormatter: NgbDateParserFormatter,
    private businessService: BusinessService,
    private userService: UserService,
    private toastService: ToastrService,
    public loaderService: LoaderService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private deviceDetector: DeviceDetectorService,
    private pageTitle: PageTitleService,
    public tour: TourService,
    private whatsOn: WhatsOnService
  ) {
    this.isMobile = deviceDetector.isMobile();
    this.isTablet = deviceDetector.isTablet();
    this.isDesktop = deviceDetector.isDesktop();
  }
  activeDishPanel = 1;
  active = 'top';
  activePhotoPanel = 0;
  isCaroselLoading = true;
  isStatic = false;
  isImageExpanded = false;
  activeCategoryPanel = 0;
  /** Paid What's On placement: adds the What's On tab and the header's "See Deals". */
  whatsOnAvailable = false;
  /** Set by "See Deals" to make the What's On tab pulse until it is opened. */
  whatsOnBeckon = false;
  @ViewChild('whatsOnNavLink') whatsOnNavLink?: ElementRef<HTMLElement>;

  // Slider With Thumb Code
  @ViewChild('sliderRef') sliderRef!: ElementRef<HTMLElement>;
  @ViewChild('thumbnailRef') thumbnailRef!: ElementRef<HTMLElement>;
  @ViewChild('sliderWithThumbWrap') sliderWithThumbWrap!: ElementRef<HTMLElement>;
  @ViewChildren('sliderRefInner') sliderRefsInner!: QueryList<
    ElementRef<HTMLElement>
  >;
  @ViewChild('GoogleMap') map: any;
  @ViewChild('tourMenuHost') set tourMenuHost(reference: ElementRef<HTMLElement> | undefined) {
    this.tourMenuElement?.removeEventListener('load', this.onTourMenuImageEvent, true);
    this.tourMenuElement?.removeEventListener('error', this.onTourMenuImageEvent, true);
    this.tourMenuElement = reference?.nativeElement;
    this.tourMenuElement?.addEventListener('load', this.onTourMenuImageEvent, true);
    this.tourMenuElement?.addEventListener('error', this.onTourMenuImageEvent, true);
  }

  slider!: KeenSliderInstance;
  thumbnailSlider!: KeenSliderInstance;
  currentSlide: number = 0;
  businessDetails: Business = new Business();
  menuCategories: KeyTitleModel[] = [];
  photoCategories: KeyNameModel[] = [];
  galleryImages: GalleryImageModel[] = [];
  filteredGalleryImages: GalleryImageModel[] = [];
  // How many products each menu category holds; read by the tab badges every CD pass.
  productCountByCategory: Record<number, number> = {};
  images: GalleryImageModel[] = [];
  sliderInner!: KeenSliderInstance[];
  sliderCreated: boolean = false;
  products: BusinessMenu[] = [];
  filterProducts: any[] = [];

  formattedHours: string[] = [];
  staticFormattedHours: string = '';
  initialCoordinates = {
    lat: 23.0346735,
    lng: 72.4979519,
  };
  branchId: number;
  mapOptions: google.maps.MapOptions = {
    center: this.initialCoordinates,
    zoom: 15,
    mapTypeControl: false,
    zoomControl: false,
    streetViewControl: false,
    disableDefaultUI: true,
    mapId: GOOGLE_MAP_ID
  };
  markers: google.maps.marker.AdvancedMarkerElement[] = [];
  currentLocation: any;
  toolTipHours: any[] = [];
  // Resolved hrefs for the contact block; '' renders that row as plain "-" text
  // rather than a dead link (see contact-links.ts / directions.ts).
  contactLinks = { tel: '', website: '', instagram: '', twitter: '', directions: '' };
  hoursTooltipTriggers = tooltipTriggers();
  isSliderExist: boolean = false;
  reviewList: any[] = [];
  bannerImages = ['./assets/images/banner-1.webp', './assets/images/banner-2.webp', './assets/images/banner-3.webp']
  selectedImages: any[] = [];
  gallaryImageList: any[] = [];
  currentCategoryImageIndex: { [Key: string]: number } = {};
  activeCategory: string = 'Faced';
  thumbImageList: any[] = [];
  lastActiveCategory: string | null = null;

  getFormattedDate(date: NgbDateStruct): string {
    if (!date) return '';
    const jsDate = new Date(date.year, date.month - 1, date.day);
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    const day = days[jsDate.getDay()];
    const month = months[jsDate.getMonth()];
    const year = jsDate.getFullYear();

    // Formatted date string
    return `${day}, ${month} ${jsDate.getDate()}`;
  }

  peopleSelect!: number;
  timeSelect!: number;
  peoples = [
    { id: 1, name: '2 people' },
    { id: 2, name: '4 people' },
    { id: 3, name: '8 people' },
  ];

  times = [
    { id: 1, name: '8:00 pm' },
    { id: 2, name: '9:00 pm' },
    { id: 3, name: '10:00 pm' },
  ];

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.setDeviceType(event.target.innerWidth);
    if (this.isImageExpanded) {
      this.syncExpandedImageHeight();
    }
    setTimeout(() => {
      if (this.sliderInner) {
        this.sliderInner.forEach((ref) => {
          ref.update();
        });
      }
      // Width drives a landscape photo's height, so the track has to be re-measured
      // once the sliders have settled at the new width.
      this.syncExpandedTrackHeight();
    }, 200);
  }

  toggleImageExpand(event?: Event): void {
    event?.stopPropagation();
    this.isImageExpanded = !this.isImageExpanded;
    this.onTourPhotoInteraction();
    this.prepareGalleryImages();

    // Measuring has to wait for change detection to put `.is-image-expanded` on the
    // wrapper, because the thumbnail rail's margin — part of the budget — only flips
    // to its expanded value then. The CSS `calc(100dvh - …)` fallback covers this frame.
    setTimeout(() => {
      if (this.isImageExpanded) {
        this.syncExpandedImageHeight();
      }
      this.slider?.update();
      if (this.sliderInner?.length) {
        this.sliderInner.forEach((innerSlider) => innerSlider.update());
      }
      if (this.isImageExpanded) {
        // After the sliders have re-measured, so the photo has its final width and the
        // track height is taken from a settled layout.
        this.syncExpandedTrackHeight();
        this.scrollExpandedImageIntoView();
      }
    });
  }

  private setDeviceType(width: number): void {
    if (width <= 768) {
      this.isMobile = true;
      this.isTablet = false;
      this.isDesktop = false;
    } else if (width <= 1024) {
      this.isTablet = true;
      this.isMobile = false;
      this.isDesktop = false;
    } else {
      this.isDesktop = true;
      this.isMobile = false;
      this.isTablet = false;
    }
  }

  /**
   * Publishes the vertical budget an expanded photo may occupy. It is a CAP, not a
   * reservation: the CSS lets the box shrink to the photo, so a landscape shot on a
   * narrow screen no longer leaves several hundred pixels of empty white below it.
   *
   * Must run after change detection has applied `.is-image-expanded`, since the
   * thumbnail rail's own margin flips from -70px (overlapping the photo) to +8px
   * (sitting below it) and that margin is part of the budget.
   */
  private syncExpandedImageHeight(): void {
    const wrap = this.sliderWithThumbWrap?.nativeElement;
    if (!wrap) {
      return;
    }

    // visualViewport is the area genuinely on screen. window.innerHeight still counts the
    // strip behind a mobile browser's collapsing address bar, so it over-reports by ~60-100px
    // and pushed the thumbnail rail off the bottom of the screen.
    const viewportHeight = window.visualViewport?.height ?? window.innerHeight;
    const rail = this.thumbnailRef?.nativeElement?.closest('.thumb-wrap') as HTMLElement | null;
    const railSpace = rail
      ? rail.getBoundingClientRect().height + (parseFloat(getComputedStyle(rail).marginTop) || 0)
      : 0;
    const breathingRoom = this.isMobile ? 24 : 40;
    const available = Math.max(
      BusinessDetailComponent.MIN_EXPANDED_IMAGE_HEIGHT,
      viewportHeight - railSpace - breathingRoom
    );
    wrap.style.setProperty('--expanded-image-height', `${Math.round(available)}px`);
  }

  /** Never collapse the expanded view to nothing, however cramped the window. */
  private static readonly MIN_EXPANDED_IMAGE_HEIGHT = 320;

  /**
   * Sizes the carousel track to the photo actually on screen.
   *
   * A flex track is as tall as its TALLEST child, and the children here are every photo
   * in every category. One portrait shot was therefore giving every landscape shot in
   * every other category a box hundreds of pixels taller than itself. Only the visible
   * photo should decide the height.
   */
  private syncExpandedTrackHeight(): void {
    const wrap = this.sliderWithThumbWrap?.nativeElement;
    if (!wrap || !this.isImageExpanded) {
      return;
    }
    const category = wrap.querySelectorAll('.top-slider > .keen-slider__slide')[this.currentSlide];
    const innerIndex = this.sliderInner?.[this.currentSlide]?.track?.details?.rel ?? 0;
    const slide = category?.querySelectorAll('.inner-slider > .keen-slider__slide')[innerIndex];
    const height = slide?.querySelector('img')?.getBoundingClientRect().height;
    // 0 while a photo is still decoding; the load handler calls back in that case.
    if (height) {
      wrap.style.setProperty('--expanded-track-height', `${Math.round(height)}px`);
    }
  }

  /** Both budgets, in the order they depend on each other. */
  private syncExpandedLayout(): void {
    this.syncExpandedImageHeight();
    this.syncExpandedTrackHeight();
  }

  /** A photo has no measurable height until it decodes; re-measure once it does. */
  onExpandedImageLoad(event?: Event): void {
    if ((event?.target as HTMLImageElement)?.getAttribute('src') === IMAGE_SKELETON_PIXEL) return;
    if (this.isImageExpanded) {
      this.syncExpandedTrackHeight();
    }
    if (event) this.recordTourImage(event);
  }

  onTourPhotoError(event: Event): void { this.recordTourImage(event); }

  // Image load/error does not bubble. Capture it on the real menu ancestor so
  // lazy category contents report their displayed media without changing the shared item.
  private readonly onTourMenuImageEvent = (event: Event): void => {
    if ((event.target as Element)?.matches?.('app-menu-section img.food-preview')) {
      this.recordTourImage(event);
    }
  };

  // A mobile browser collapsing or revealing its address bar changes the visible height
  // WITHOUT firing window:resize, so the budget would stay stale until the next rotation.
  private readonly onViewportResize = () => {
    if (this.isImageExpanded) {
      this.syncExpandedLayout();
    }
  };

  private watchViewportHeight(): void {
    window.visualViewport?.addEventListener('resize', this.onViewportResize);
  }

  private unwatchViewportHeight(): void {
    window.visualViewport?.removeEventListener('resize', this.onViewportResize);
  }

  private scrollExpandedImageIntoView(): void {
    this.sliderWithThumbWrap?.nativeElement?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }

  ngOnInit() {
    this.watchViewportHeight();
    this.viewSubscriptions.add(this.tour.state$.pipe(
      map(() => `${this.tour.active}:${this.tour.step}`),
      distinctUntilChanged()
    ).subscribe(() => {
      this.tourPhotoInteracted = false;
      clearTimeout(this.tourStepTimer);
      this.tourStepTimer = setTimeout(() => {
        this.prepareGalleryImages();
        this.prepareTourStep();
      });
    }));
    this.viewSubscriptions.add(this.route.params.pipe(
      map(params => Number(params['id'])), distinctUntilChanged()
    ).subscribe(branchId => {
      this.branchId = branchId;
      this.loadRestaurant();
    }));
    this.loadMap();
    this.selectedImages = this.getRandomImages(this.bannerImages, 2);
  }

  loadRestaurant(): void {
    this.restaurantSubscriptions.unsubscribe();
    this.restaurantSubscriptions = new Subscription();
    this.routeGeneration++;
    this.resetRestaurant();
    // A route-local status takes over any loader left by the listing we just left.
    this.loaderService.setLoading(false);
    if (!Number.isInteger(this.branchId) || this.branchId <= 0) {
      this.failRestaurant();
      return;
    }
    this.restaurantSubscriptions.add(quietRead(() => this.businessService.getBusinessById(this.branchId, this.quietContext)).pipe(
      map(response => {
        if (!response || !response.branchId) throw new Error('Restaurant unavailable');
        return response;
      })
    ).subscribe({
      next: response => {
        this.applyRestaurant(response);
        this.detailLoading = false;
        this.tourDataLoaded = true;
        this.loadPhotos();
        this.loadMenu();
        this.loadReviews();
        this.loadWhatsOn();
      },
      error: () => this.failRestaurant()
    }));
  }

  /**
   * The shared business detail DTO deliberately carries no subscription state, so the
   * paid placement is a separate read. Only a true answer adds anything to the page.
   */
  private loadWhatsOn(): void {
    if (!this.whatsOn.enabled) return;
    this.restaurantSubscriptions.add(this.whatsOn.watchAvailability(this.businessDetails.branchId).subscribe(available => {
      this.whatsOnAvailable = available;
      if (!available) {
        this.whatsOnBeckon = false;
        this.cancelMenuSettle?.();
        if (this.active === 'whats-on') this.active = 'top';
      }
    }));
  }

  /**
   * "See Deals": bring the menu section into view and make its What's On tab beckon.
   * The tab stays the visitor's to open; it is focused so Enter opens it from a keyboard.
   */
  seeDeals(): void {
    const menu = this.tourMenuElement;
    if (!menu || !this.whatsOnAvailable) return;
    const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    this.scrollMenuIntoView(menu, reduceMotion ? 'auto' : 'smooth');
    // Off first, then on in a later task, so a repeated click restarts the pulse.
    this.whatsOnBeckon = false;
    this.scheduleRestaurantView(() => {
      if (!this.whatsOnAvailable || this.active === 'whats-on') return;
      this.whatsOnBeckon = true;
      this.whatsOnNavLink?.nativeElement.focus({ preventScroll: true });
    });
  }

  onWhatsOnTabOpened(): void {
    this.whatsOnBeckon = false;
    this.whatsOn.refreshAvailability();
  }

  /**
   * Photos and the map above the menu can still be growing during and shortly after the
   * scroll, which would leave it short of the tabs. Once the scroll has ended, keep the
   * tabs in place for a few seconds (as scroll anchoring would), and stop the moment the
   * visitor scrolls, taps or types.
   */
  private scrollMenuIntoView(menu: HTMLElement, behavior: ScrollBehavior): void {
    this.cancelMenuSettle?.();
    menu.scrollIntoView({ behavior, block: 'start' });
    const userEvents = ['wheel', 'touchstart', 'keydown', 'mousedown'];
    let scrolling = behavior === 'smooth';
    let frame = 0;
    let watchUntil = Date.now() + BusinessDetailComponent.MENU_SETTLE_MS;
    const scrollEnded = () => {
      if (!scrolling) return;
      scrolling = false;
      watchUntil = Date.now() + BusinessDetailComponent.MENU_SETTLE_MS;
    };
    // Browsers without `scrollend` treat the smooth scroll as finished after this long.
    const scrollTimer = setTimeout(scrollEnded, 1200);
    if (scrolling) watchUntil += 1200;
    const cleanup = () => {
      clearTimeout(scrollTimer);
      cancelAnimationFrame(frame);
      window.removeEventListener('scrollend', scrollEnded);
      userEvents.forEach(type => window.removeEventListener(type, cleanup, true));
      if (this.cancelMenuSettle === cleanup) this.cancelMenuSettle = undefined;
    };
    const keepInPlace = () => {
      if (this.destroyed || !menu.isConnected || Date.now() > watchUntil) { cleanup(); return; }
      if (!scrolling) {
        const wanted = parseFloat(getComputedStyle(menu).scrollMarginTop) || 0;
        // At the end of the page this is a no-op; the browser cannot scroll further.
        if (Math.abs(menu.getBoundingClientRect().top - wanted) > 8) menu.scrollIntoView({ behavior: 'auto', block: 'start' });
      }
      frame = requestAnimationFrame(keepInPlace);
    };
    window.addEventListener('scrollend', scrollEnded);
    userEvents.forEach(type => window.addEventListener(type, cleanup, true));
    frame = requestAnimationFrame(keepInPlace);
    this.cancelMenuSettle = cleanup;
    this.restaurantSubscriptions.add(cleanup);
  }
  private cancelMenuSettle?: () => void;
  /** How long after the scroll the tabs are held in place while the page above settles. */
  private static readonly MENU_SETTLE_MS = 2500;

  private applyRestaurant(response: any): void {
    this.businessDetails = { ...response, membershipBusinessImagesList: response.membershipBusinessImagesList || [],
      membershipAppCompanyBusinessHourList: (response.membershipAppCompanyBusinessHourList || []).map(hour => ({ ...hour, from: hour.from || '', to: hour.to || '' })) };
    this.pageTitle.set(response?.name);
    this.contactLinks = {
      tel: toTelUrl(response?.phoneNumber),
      website: toWebsiteUrl(response?.website),
      instagram: toInstagramUrl(response?.instagram),
      twitter: toTwitterUrl(response?.twitter),
      directions: directionsUrl(response?.lat, response?.lng, response?.address),
    };

    // If lat/lng are available, update map center and add marker
    if (this.hasMapLocation) {
      this.initialCoordinates = {
        lat: this.businessDetails.lat,
        lng: this.businessDetails.lng
      };

      // Only update center and zoom, not the entire options
      if (this.map?.googleMap) {
        this.map.googleMap.setCenter(this.initialCoordinates);
        this.map.googleMap.setZoom(15);
      }


    }
    this.businessDetails.status = this.businessDetails
      ?.membershipAppCompanyBusinessHourList?.length
      ? businessStatus.isBusinessOpen(
        this.businessDetails.membershipAppCompanyBusinessHourList
      )
        ? 'open now'
        : 'closed now'
      : '';
    if (
      this.businessDetails.membershipAppCompanyBusinessHourList?.length
    ) {
      this.businessDetails.membershipAppCompanyBusinessHourList.forEach(
        (hour) => {
          if (hour.from != '' || hour.to != '') {
            if (hour.from.length == 7) {
              hour.from = '0' + hour.from;
            }
            if (hour.to.length == 7) {
              hour.to = '0' + hour.to;
            }
          }
        }
      );
      this.formattedHours = businessHours.groupBySameTiming(
        this.businessDetails.membershipAppCompanyBusinessHourList
      );
      this.businessDetails.membershipAppCompanyBusinessHourList.sort(
        (a, b) => a.day - b.day
      );
      const hours =
        this.businessDetails.membershipAppCompanyBusinessHourList;
      hours.forEach((hour) => {
        hour.day = businessHours.getDayName(hour.day);
        this.toolTipHours.push(hour);
      });
    }
  }

  loadPhotos(): void {
    if (!this.hasBusinessPhotos) {
      this.photosLoading = this.photosError = this.isCaroselLoading = false;
      this.prepareTourStep();
      return;
    }
    if (this.photosLoading && this.photoCategories.length) return;
    this.photosLoading = true;
    this.photosError = false;
    this.restaurantSubscriptions.add(quietRead(() => this.userService.getAll('api/getEnumList/MembershipBranchImageType', this.quietContext)).pipe(
      map((items: any[]) => items.map(item => ({ id: item.value, name: item.enumName })))
    ).subscribe({
      next: categories => {
        this.applyPhotoCategories(categories);
        this.photosLoading = false;
        this.prepareTourStep();
      },
      error: () => {
        this.photosLoading = false;
        this.photosError = true;
        // Category labels must not hide photos already supplied by the detail response.
        const ids = [...new Set(this.businessDetails.membershipBusinessImagesList
          .filter(image => !image.isDeleted && !!image.imagePath?.trim()).map(image => image.imageType))];
        this.applyPhotoCategories(ids.map(id => ({ id, name: MembershipBranchImageType[id] || 'Photos' })));
        this.prepareTourStep();
      }
    }));
  }

  private applyPhotoCategories(categories: KeyNameModel[]): void {
    this.galleryImages = [];
    this.images = [];
    this.photoCategories = categories;
    categories.forEach(category => { this.pushDataInGalleryImages(category); this.pushDataInImages(category); });
    if (!this.images[this.activePhotoPanel]?.images.length) {
      this.activePhotoPanel = Math.max(0, this.images.findIndex(category => category.images.length > 0));
    }
    this.prepareGalleryImages();
    if (this.active === 'middle') this.preparePhotoCategory();
    if (!this.isSliderExist) this.isCaroselLoading = false;
    this.scheduleRestaurantView(() => {
      if (!this.sliderCreated && this.filteredGalleryImages.length) this.sliderFunction();
      else { this.slider?.update(); this.thumbnailSlider?.update(); }
    });
  }

  loadMenu(): void {
    this.menuLoading = true;
    this.menuError = false;
    this.restaurantSubscriptions.add(zip(
      quietRead(() => this.userService.getAll(`api/tenants/membershipApp/GetAllMembershipProductCategories?businessPartnerId=${this.businessDetails.businessPartnerId}`, this.quietContext)),
      quietRead(() => this.userService.getAll(`api/tenants/membershipApp/GetCompanyMenue?SubBranchId=${this.businessDetails.branchId}&SkipPaging=true`, this.quietContext))
    ).pipe(map(([categories, products]: any[]) => ({
      categories: Function.sortItems(categories.map(item => ({ id: item.id, title: item.title }))),
      products: products.records.map(product => ({
        id: product.id, title: product.title, productCategoryId: product.productCategoryId,
        productImageUrl: product.image, price: product.price, description: product.description,
        productImageId: product.productImages?.[0]?.id
      }))
    }))).subscribe({
      next: result => {
        this.menuCategories = result.categories;
        this.products = result.products;
        this.productCountByCategory = {};
        this.products.forEach(product => {
          this.productCountByCategory[product.productCategoryId] = (this.productCountByCategory[product.productCategoryId] || 0) + 1;
        });
        const category = this.menuCategories.find(item => this.productCountByCategory[item.id]) || this.menuCategories[0];
        if (category) {
          this.activeCategoryPanel = category.id;
          this.getProductsByCategoryId(category.id);
        }
        this.menuLoading = false;
        this.prepareTourStep();
      },
      error: () => {
        this.menuLoading = false;
        this.menuError = true;
        this.prepareTourStep();
      }
    }));
  }

  loadReviews(): void {
    this.reviewsLoading = true;
    this.reviewsError = false;
    this.restaurantSubscriptions.add(quietRead(() => this.userService.getAll(
      `api/clients/getReviewNotes?isForReview=true&branchId=${this.businessDetails.branchId}&businessPartnerId=${this.businessDetails.businessPartnerId}`, this.quietContext
    )).pipe(map((response: any) => response.records.map(review => ({
      avatar: review.createdBy?.photo || './assets/images/review-avatar-2.png',
      name: review.createdBy?.title || '', date: review.createdOn, rating: review.rating,
      ratingIcon: './assets/images/ic-primary-rating.svg', ratedTime: this.getDaysAgoLabel(review.createdOn),
      reviewText: review.notes || '', numPhotos: review.crmNoteImages?.length || 0,
      reply: null, crmNoteImages: review.crmNoteImages || [], tagsList: review.tagsList || []
    })))).subscribe({
      next: reviews => { this.reviewList = reviews; this.reviewsLoading = false; },
      error: () => { this.reviewsLoading = false; this.reviewsError = true; }
    }));
  }

  private failRestaurant(): void {
    this.detailLoading = false;
    this.detailError = true;
    this.photosLoading = this.menuLoading = this.reviewsLoading = false;
    this.notifyTourLoadFailure();
  }

  @HostListener('window:online')
  @HostListener('window:focus')
  recoverBackgroundReads(): void {
    if (this.destroyed || Date.now() < this.recoveryAfter) return;
    if (!this.detailError && !this.photosError && !this.menuError && !this.reviewsError && !this.mapsError) return;
    this.recoveryAfter = Date.now() + 30000;
    if (this.detailError && !this.detailLoading) { this.loadRestaurant(); return; }
    if (this.photosError && !this.photosLoading) this.loadPhotos();
    if (this.menuError && !this.menuLoading) this.loadMenu();
    if (this.reviewsError && !this.reviewsLoading) this.loadReviews();
    if (this.mapsError) this.loadMap();
  }

  private resetRestaurant(): void {
    this.destroySliders();
    this.croppedImageUrls.forEach(url => URL.revokeObjectURL(url));
    this.croppedImageUrls.clear();
    this.preparedPhotoCategories.clear();
    this.requestedGalleryImages.clear();
    this.preparedGalleryCrops.clear();
    this.failedGalleryProfiles.clear();
    this.failedThumbnailProfiles.clear();
    this.galleryImageIndices = {};
    this.markers.forEach(marker => marker.map = null);
    this.markers = [];
    this.detailLoading = this.photosLoading = this.menuLoading = this.reviewsLoading = true;
    this.detailError = this.photosError = this.menuError = this.reviewsError = false;
    this.tourDataLoaded = this.tourLoadFailed = this.tourPhotoInteracted = false;
    this.loadedTourImages.clear();
    this.failedTourImages.clear();
    this.businessDetails = new Business();
    this.galleryImages = [];
    this.filteredGalleryImages = [];
    this.images = [];
    this.photoCategories = [];
    this.menuCategories = [];
    this.products = [];
    this.filterProducts = [];
    this.productCountByCategory = {};
    this.reviewList = [];
    this.formattedHours = [];
    this.toolTipHours = [];
    this.currentLocation = undefined;
    this.initialCoordinates = { lat: 23.0346735, lng: 72.4979519 };
    this.contactLinks = { tel: '', website: '', instagram: '', twitter: '', directions: '' };
    this.currentSlide = this.activeCategoryPanel = this.activePhotoPanel = 0;
    this.active = 'top';
    this.whatsOnAvailable = this.whatsOnBeckon = false;
    this.isImageExpanded = this.isSliderExist = false;
    this.isCaroselLoading = true;
    this.selectedIndex = this.selectedProduct = null;
  }

  private destroySliders(): void {
    this.slider?.destroy();
    this.thumbnailSlider?.destroy();
    this.sliderInner?.forEach(slider => slider.destroy());
    this.slider = this.thumbnailSlider = undefined;
    this.sliderInner = [];
    this.sliderCreated = false;
  }

  private scheduleRestaurantView(callback: () => void): void {
    const generation = this.routeGeneration;
    const handle = setTimeout(() => {
      if (!this.destroyed && generation === this.routeGeneration) callback();
    });
    this.restaurantSubscriptions.add(() => clearTimeout(handle));
  }

  onMapInitialized(map: google.maps.Map): void {
    // GoogleMap emits during its ngOnInit, before the parent ViewChild is set.
    void this.markLocation(this.businessDetails.lat, this.businessDetails.lng, map);
  }

  get hasMapLocation(): boolean {
    const { lat, lng } = this.businessDetails;
    return Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180;
  }

  get hasBusinessPhotos(): boolean {
    return this.businessDetails.membershipBusinessImagesList?.some(image => !image.isDeleted && !!image.imagePath?.trim()) || false;
  }

  loadMap(): void {
    // The SDK may arrive after an initial timeout. Retry only the map, keeping all
    // restaurant content available while waiting for the existing script.
    this.mapsSubscription?.unsubscribe();
    this.mapsError = false;
    this.mapsSubscription = quietRead(() => timer(0, 100).pipe(
      filter(() => typeof google !== 'undefined' && !!google.maps?.Map),
    ), 10000).subscribe({ next: () => this.mapsReady = true, error: () => this.mapsError = true });
  }

  getRandomImages(array: string[], count: number): string[] {
    const shuffled = [...array].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
  }

  private loadCropSource(imageSrc: string): Observable<HTMLImageElement> {
    return new Observable<HTMLImageElement>(observer => {
      if (!imageSrc) { observer.error(new Error('Missing image')); return undefined; }
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => { observer.next(img); observer.complete(); };
      img.onerror = () => observer.error(new Error('Image load error'));
      img.src = imageSrc;
      return () => {
        img.onload = img.onerror = null;
        img.removeAttribute('src');
      };
    }).pipe(timeout(this.requestTimeout));
  }

  cropImage(imageSrc: string, x: number, y: number, width: number, height: number, widthRsp: number, heightRsp: number): Observable<string> {
    return this.loadCropSource(imageSrc).pipe(map(img => {
      const canvas = document.createElement('canvas');
      canvas.width = widthRsp;
      canvas.height = heightRsp;
      const ctx = canvas.getContext('2d');
      if (!ctx) throw new Error('Canvas unavailable');
      ctx.drawImage(img, x, y, width, height, 0, 0, widthRsp, heightRsp);
      return canvas.toDataURL('image/png');
    }));
  }

  cropMobileImage(imageSrc: string, sx: number, sy: number, sw: number, sh: number, displayW: number, displayH: number): Observable<CropResult> {
    return new Observable(observer => {
      const source = this.loadCropSource(imageSrc).subscribe({
        next: img => {
          try {
            const dpr = window.devicePixelRatio || 1;
            const pixelW = displayW * dpr;
            const pixelH = displayH * dpr;
            const canvas = document.createElement('canvas');
            canvas.width = pixelW;
            canvas.height = pixelH;
            const ctx = canvas.getContext('2d');
            if (!ctx) throw new Error('Canvas unavailable');
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';
            ctx.scale(dpr, dpr);
            ctx.drawImage(img, sx, sy, sw, sh, 0, 0, displayW, displayH);
            canvas.toBlob(blob => {
              if (observer.closed) return;
              if (!blob) { observer.error(new Error('Failed to crop image')); return; }
              observer.next({ blob, pixelW, pixelH });
              observer.complete();
            }, 'image/png', 1);
          } catch (error) { observer.error(error); }
        },
        error: error => observer.error(error)
      });
      return () => source.unsubscribe();
    });
  }

  sliderFunction() {
    if (!this.sliderRef?.nativeElement || !this.thumbnailRef?.nativeElement) {
      return;
    }

    this.slider = new KeenSlider(
      this.sliderRef.nativeElement,
      {
        initial: this.currentSlide,
        slideChanged: (s) => {
          this.onGalleryCategoryChanged(s.track.details.rel);
          // Moving to another category means a different photo decides the height.
          this.syncExpandedTrackHeight();
        },
        dragEnded: () => this.onTourPhotoInteraction(),
        rubberband: false,
        breakpoints: {
          '(max-width: 575px)': {
            slides: { spacing: 12 },
          },
        },
        selector: '.top-slider > .keen-slider__slide',
      },
      [
        (slider) => {
          slider.on('created', (s) => {
            const slideElements = s.slides;
            slideElements.forEach((slide, index) => {
              if (index === this.currentSlide) {
                slide.classList.add('active');
              } else {
                slide.classList.remove('active');
              }
            });
          });
          slider.on('slideChanged', (s) => {
            const slideElements = s.slides;
            slideElements.forEach((slide, index) => {
              if (index === s.track.details.abs) {
                slide.classList.add('active');
              } else {
                slide.classList.remove('active');
              }
            });
          });
        },
      ]
    );

    this.thumbnailSlider = new KeenSlider(
      this.thumbnailRef.nativeElement,
      {
        initial: 0,
        dragEnded: () => this.onTourPhotoInteraction(),
        slides: {
          perView: 4,
          spacing: 0,
        },
        breakpoints: {
          '(max-width: 575px)': {
            slides: { perView: 4, spacing: 8 },
          },
        },
      },
      [this.ThumbnailPlugin(this.slider)]
    );
    this.sliderInner = [];
    this.scheduleRestaurantView(() => {
      this.sliderRefsInner.forEach((ref, categoryIndex) => {
        this.sliderInner.push(
          new KeenSlider(ref.nativeElement, {
            dragEnded: () => this.onTourPhotoInteraction(),
            rubberband: false,
            slides: {
              perView: 1,
            },
            // Paging within a category swaps to a photo of a different shape.
            slideChanged: slider => {
              this.onGalleryImageChanged(categoryIndex, slider.track.details.rel);
              this.syncExpandedTrackHeight();
            },
          })
        );
      });
      this.sliderCreated = true;
      this.isCaroselLoading = false;
    });
  }

  ngOnDestroy() {
    this.destroyed = true;
    this.routeGeneration++;
    clearTimeout(this.tourStepTimer);
    this.restaurantSubscriptions.unsubscribe();
    this.mapsSubscription?.unsubscribe();
    this.viewSubscriptions.unsubscribe();
    this.tourMenuElement?.removeEventListener('load', this.onTourMenuImageEvent, true);
    this.tourMenuElement?.removeEventListener('error', this.onTourMenuImageEvent, true);
    this.unwatchViewportHeight();
    this.destroySliders();
    this.croppedImageUrls.forEach(url => URL.revokeObjectURL(url));
    this.croppedImageUrls.clear();
    this.markers.forEach(marker => marker.map = null);
  }

  ThumbnailPlugin(main: KeenSliderInstance): KeenSliderPlugin {
    return (slider) => {
      function removeActive() {
        slider.slides.forEach((slide) => {
          slide.classList.remove('active');
        });
      }
      function addActive(idx: number) {
        slider.slides[idx].classList.add('active');
      }

      function addClickEvents() {
        slider.slides.forEach((slide, idx) => {
          slide.addEventListener('click', () => {
            main.moveToIdx(idx);
          });
        });
      }

      slider.on('created', () => {
        if (slider.track.details) {
          addActive(slider.track.details.rel);
          addClickEvents();
          main.on('animationStarted', (main) => {
            removeActive();
            const next = main.animator.targetIdx || 0;
            addActive(main.track.absToRel(next));
            slider.moveToIdx(Math.min(slider.track.details.maxIdx, next));
          });
        }
      });
    };
  }

  checkNoRecord(categoryId: number) {
    return !this.productCountByCategory[categoryId];
  }

  trackByEntityId(index: number, item: any): number {
    return item?.id ?? index;
  }

  async markLocation(lat: number, lng: number, map: google.maps.Map = this.map?.googleMap) {
    if (!this.hasMapLocation) return;

    this.initialCoordinates = {
      lat: lat,
      lng: lng,
    };

    // Clear existing markers
    this.markers.forEach((marker: any) => {
      if (marker.map) marker.map = null;
    });
    this.markers.length = 0;

    const generation = this.routeGeneration;
    if (!this.mapsReady || !map) return;
    let AdvancedMarkerElement: typeof google.maps.marker.AdvancedMarkerElement;
    try {
      ({ AdvancedMarkerElement } = await google.maps.importLibrary('marker') as google.maps.MarkerLibrary);
    } catch { return; }
    if (this.destroyed || generation !== this.routeGeneration) return;

    // Create marker element with the same style as listing page
    const element = document.createElement('div');
    element.innerHTML = `
      <div style="position: relative; cursor: pointer;">
        <img src="./assets/images/location-listing-page.svg" style="width: 45px; height: 56px;"/>
        <div style="position: absolute; top: 35%; left: 50%; transform: translate(-50%, -50%); color: white; font-size: 12px; font-weight: 500; font-family: Barlow;">
          
        </div>
      </div>
    `;

    const marker = new AdvancedMarkerElement({
      map,
      position: this.initialCoordinates,
      title: this.businessDetails?.name || 'Location'
    });
    marker.append(element);

    this.markers.push(marker);
  }

  highlight($event) {
    this.setMarkerHighlight($event, true);
  }

  removeHighlight($event) {
    this.setMarkerHighlight($event, false);
  }

  /**
   * Swaps the pin image on the existing marker content. The previous version
   * built a fresh innerHTML tree and replaced `marker.content` on every event —
   * and the header fired those events for every child the pointer crossed.
   * Idempotent, so repeated events while hovered cost one string compare.
   */
  private setMarkerHighlight($event: { lat?: number; lng?: number }, highlighted: boolean) {
    const hasCoords = $event?.lat != 0 && $event?.lat != undefined && $event?.lng != 0 && $event?.lng != undefined;
    const marker = hasCoords
      ? this.markers.find((m) => m.position.lat === $event.lat && m.position.lng === $event.lng)
      : this.markers[0];
    const img = marker?.querySelector('img');
    if (!img) return;
    const src = highlighted
      ? './assets/images/location-listing-page-3.svg'
      : './assets/images/location-listing-page.svg';
    if (img.getAttribute('src') !== src) {
      img.setAttribute('src', src);
    }
  }

  pushDataInGalleryImages = (category: KeyNameModel) => {
    let images = this.businessDetails.membershipBusinessImagesList
      .filter((x) => x.imageType == category.id && !x.isDeleted && !!x.imagePath?.trim())
      .map((item) => ({
        src: item.imagePath
      }));

    this.galleryImages.push({
      id: category.id,
      category: category.name,
      images: images
    });
    this.filteredGalleryImages = this.galleryImages.filter(
      (imageArray) => imageArray.images.length > 0
    );
    this.isSliderExist = this.filteredGalleryImages.length > 0;
  }

  onGalleryCategoryChanged(index: number): void {
    this.currentSlide = index;
    this.prepareGalleryImages();
    this.reportTourMediaReadiness();
  }

  onGalleryImageChanged(categoryIndex: number, imageIndex: number): void {
    this.galleryImageIndices[categoryIndex] = imageIndex;
    this.prepareGalleryImages();
    this.reportTourMediaReadiness();
  }

  private galleryImageKey(categoryIndex: number, imageIndex: number): string {
    return `${categoryIndex}:${imageIndex}`;
  }

  // Native lazy loading cannot defer `new Image()` inside a crop, and horizontal
  // carousels often count as near the viewport. Gate both requests explicitly.
  // Keep the active photo and its neighbours ready while preserving every slide
  // shell so Keen's sizing, swipe positions and thumbnail navigation stay stable.
  private prepareGalleryImages(): void {
    for (let categoryIndex = Math.max(0, this.currentSlide - 1);
      categoryIndex <= Math.min(this.filteredGalleryImages.length - 1, this.currentSlide + 1); categoryIndex++) {
      const category = this.filteredGalleryImages[categoryIndex];
      const selectedImage = this.galleryImageIndices[categoryIndex] || 0;
      for (let imageIndex = Math.max(0, selectedImage - 1);
        imageIndex <= Math.min(category.images.length - 1, selectedImage + 1); imageIndex++) {
        const key = this.galleryImageKey(categoryIndex, imageIndex);
        this.requestedGalleryImages.add(key);
        // Expanded photos display the original. Only produce a crop when its
        // configured preview will actually be used.
        if (this.isImageExpanded || this.preparedGalleryCrops.has(key)) continue;
        const image = category.images[imageIndex];
        const profile = restaurantImageUrl(image.src, this.isMobile ? 'mobile' : 'hero');
        // Profiles already apply the saved original-pixel crop on the server.
        // Downloading and cropping the original again would discard that saving.
        if (profile !== image.src && !this.failedGalleryProfiles.has(image.src)) continue;
        this.preparedGalleryCrops.add(key);
        const configuration = this.businessDetails.membershipBusinessImagesList.find(item =>
          item.imageType == category.id && item.imagePath == image.src)?.memberShipImageConfigurationViews?.find(item =>
            item.imageType == (this.isMobile ? 3 : 1));
        this.setCroppedGalleryImages(configuration, { id: category.id, name: category.category }, image.src);
      }
    }
  }

  galleryImageSource(categoryIndex: number, imageIndex: number): string | null {
    if (!this.requestedGalleryImages.has(this.galleryImageKey(categoryIndex, imageIndex))) return null;
    const image = this.filteredGalleryImages[categoryIndex]?.images[imageIndex];
    if (!image) return null;
    return this.galleryImageUrl(image);
  }

  galleryThumbnailSource(categoryIndex: number): string | null {
    // Reuse media already prepared for the carousel. A category label remains
    // usable while its preview is deferred; the thumbnail adds no original fetch.
    if (!this.requestedGalleryImages.has(this.galleryImageKey(categoryIndex, 0))) return null;
    const image = this.filteredGalleryImages[categoryIndex]?.images[0];
    if (image?.src && !this.failedThumbnailProfiles.has(image.src)) {
      const profile = restaurantImageUrl(image.src, 'card');
      if (profile !== image.src) return profile;
    }
    return image?.croppedSrc || image?.src || null;
  }

  onGalleryImageError(categoryIndex: number, imageIndex: number, event: Event): void {
    const image = this.filteredGalleryImages[categoryIndex]?.images[imageIndex];
    const target = event.target as HTMLImageElement;
    if (image?.src && isRestaurantImageProfileUrl(target?.currentSrc || target?.src) &&
      !this.failedGalleryProfiles.has(image.src)) {
      this.failedGalleryProfiles.add(image.src);
      this.prepareGalleryImages();
      return;
    }
    this.onTourPhotoError(event);
  }

  onGalleryThumbnailError(categoryIndex: number, event: Event): void {
    const image = this.filteredGalleryImages[categoryIndex]?.images[0];
    const target = event.target as HTMLImageElement;
    if (image?.src && isRestaurantImageProfileUrl(target?.currentSrc || target?.src)) {
      this.failedThumbnailProfiles.add(image.src);
    }
  }

  setCroppedGalleryImages = (imageConfigurationDetails: any, category: KeyNameModel, image: string) => {
    if (imageConfigurationDetails) {
      let widthRsp = this.isMobile ? 382 : 1296;
      let heightRsp = this.isMobile ? 300 : 406;

      this.restaurantSubscriptions.add(this.cropMobileImage(image, imageConfigurationDetails?.x, imageConfigurationDetails?.y,
        imageConfigurationDetails?.width, imageConfigurationDetails?.height, widthRsp, heightRsp)
        .subscribe({
          next: ({ blob, pixelW, pixelH }: CropResult) => {
            const url = URL.createObjectURL(blob);
            this.croppedImageUrls.add(url);
            this.galleryImages.forEach((event) => {
              if (event.id == category.id && event.images.find(p => p.src == image)) {
                let img = event.images.find(p => p.src == image);
                img.croppedSrc = url;
                img.pixelW = pixelW;
                img.pixelH = pixelH;
              }
            });
          },
          error: () => undefined
        }));
    }
  }

  pushDataInImages = (category: KeyNameModel) => {
    let images = this.businessDetails.membershipBusinessImagesList
      .filter((x) => x.imageType == category.id && !x.isDeleted && !!x.imagePath?.trim())
      .map((item) => ({
        src: item.imagePath
      }));


    this.images.push({
      id: category.id,
      category: category.name,
      images: images
    });
  }

  // The Photos tab is below the fold and closed initially. Crop its visible category on demand.
  preparePhotoCategory(index = this.activePhotoPanel): void {
    const category = this.images[index];
    if (!category || this.preparedPhotoCategories.has(category.id)) return;
    this.preparedPhotoCategories.add(category.id);
    category.images.forEach(image => {
      const config = this.businessDetails.membershipBusinessImagesList.find(item =>
        item.imageType == category.id && item.imagePath == image.src)?.memberShipImageConfigurationViews?.find(item => item.imageType == 2);
      this.setCroppedImages(config, { id: category.id, name: category.category }, image.src);
    });
  }

  setCroppedImages = (imageConfigurationDetails: any, category: KeyNameModel, image: string) => {
    if (imageConfigurationDetails) {
      this.restaurantSubscriptions.add(this.cropImage(image, imageConfigurationDetails?.x, imageConfigurationDetails?.y,
        imageConfigurationDetails?.width, imageConfigurationDetails?.height, window.innerWidth, window.innerHeight)
        .subscribe({
          next: (cropped: any) => {
            this.images.forEach((event) => {
              if (event.id == category.id && event.images.find(p => p.src == image)) {
                let img = event.images.find(p => p.src == image);
                img.croppedSrc = cropped;
              }
            });
          },
          error: () => undefined
        }));
    }
  }

  getDaysAgoLabel(createdDateInput: string | Date): string {
    const createdDate = new Date(createdDateInput);
    const currentDate = new Date();

    createdDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    const diffTime = currentDate.getTime() - createdDate.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) {
      return 'Today';
    }
    else if (diffDays === 1) {
      return 'Yesterday';
    }
    else {
      return `${diffDays} days ago`
    }
  }

  selectProduct(product: BusinessMenu, index: number) {
    if (this.selectedProduct && this.selectedProduct.id == product.id) {
      this.selectedProduct = null;
      this.selectedIndex = null;
    } else {
      this.selectedProduct = product;
      this.selectedIndex = index;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedInside = (event.target as HTMLElement).closest('.dish-ul');
    if (!clickedInside) {
      this.selectedIndex = null;
      this.selectedProduct = null;
    }
  }

  getProductsByCategoryId(categoryId: number) {
    this.filterProducts = this.products.filter((product) => product.productCategoryId === categoryId)
      .map((product, i) => ({
        ...product,
        index: i + 1
      }));
  }

  /** A fallback illustration is never counted as a restaurant image. */
  isTourImage(url: string | null | undefined): boolean {
    return !!url?.trim() && url !== IMAGE_SKELETON_PIXEL && !/\/(?:no-image|placeholder)[^/]*\.(?:svg|png|webp)(?:[?#]|$)/i.test(url);
  }

  isTourPhotoVisible(categoryIndex: number, imageIndex: number): boolean {
    return categoryIndex === this.currentSlide &&
      imageIndex === (this.sliderInner?.[categoryIndex]?.track?.details?.rel ?? 0);
  }

  get tourPhotoRibbonReady(): boolean {
    const imageIndex = this.sliderInner?.[this.currentSlide]?.track?.details?.rel ?? 0;
    const image = this.filteredGalleryImages[this.currentSlide]?.images[imageIndex];
    return this.tour.active && this.isTourImageReady(this.galleryImageUrl(image));
  }

  galleryImageUrl(image: { src?: string; croppedSrc?: string } | undefined): string {
    if (!this.isImageExpanded && image?.src && !this.failedGalleryProfiles.has(image.src)) {
      const profile = restaurantImageUrl(image.src, this.isMobile ? 'mobile' : 'hero');
      if (profile !== image.src) return profile;
    }
    return (this.isImageExpanded ? image?.src || image?.croppedSrc : image?.croppedSrc || image?.src) || '';
  }

  isTourImageReady(url: string | null | undefined): boolean {
    return this.isTourImage(url) && this.loadedTourImages.has(this.tourImageKey(url));
  }

  private tourImageKey(url: string): string {
    try { return new URL(url, document.baseURI).href; } catch { return url; }
  }

  private recordTourImage(event: Event): void {
    const image = event.target as HTMLImageElement;
    const url = image?.currentSrc || image?.src;
    if (!this.isTourImage(url)) return;
    const key = this.tourImageKey(url);
    if (event.type === 'load' && image.complete && image.naturalWidth > 0) {
      this.loadedTourImages.add(key);
      this.failedTourImages.delete(key);
    } else if (event.type === 'error') {
      this.failedTourImages.add(key);
      this.loadedTourImages.delete(key);
    }
    this.reportTourMediaReadiness();
  }

  onTourPhotoInteraction(): void {
    if (!this.tour.active || this.tour.step !== 'photos') return;
    this.tourPhotoInteracted = true;
    this.reportTourMediaReadiness();
  }

  onTourPhotoKey(index: number, event: Event): void {
    if (!this.tour.active) return;
    event.preventDefault();
    this.slider?.moveToIdx(index);
    this.onTourPhotoInteraction();
  }

  onTourMenuKey(product: BusinessMenu, index: number, event: Event): void {
    if (!this.tour.active) return;
    event.preventDefault();
    this.selectProduct(product, index);
  }

  onTourMenuExpandedLoad(event: Event): void {
    const image = event.target as HTMLImageElement;
    const url = this.selectedProduct?.productImageUrl;
    if (this.tour.active && this.tour.step === 'menu' && this.isTourImage(url) &&
        image.complete && image.naturalWidth > 0 &&
        this.tourImageKey(image.currentSrc || image.src) === this.tourImageKey(url)) {
      this.tour.notify('menu-explored');
    }
  }

  private prepareTourStep(): void {
    if (!this.tour.active || !this.tourDataLoaded) return;
    if (this.tourLoadFailed) {
      this.notifyTourLoadFailure();
      return;
    }
    if (this.tour.step === 'menu' && !this.menuLoading) {
      this.active = 'top';
      const imageProduct = this.products.find(product =>
        this.isTourImage(product.productImageUrl) &&
        this.menuCategories.some(category => category.id === product.productCategoryId));
      if (imageProduct) {
        this.activeCategoryPanel = imageProduct.productCategoryId;
        this.getProductsByCategoryId(this.activeCategoryPanel);
      }
    }
    this.reportTourMediaReadiness();
  }

  private reportTourMediaReadiness(): void {
    if (!this.tour.active || !this.tourDataLoaded || this.tourLoadFailed) return;
    if (this.tour.step === 'photos' && !this.photosLoading) {
      if (this.photosError) { this.tour.notify('photos-unavailable'); return; }
      const urls = this.filteredGalleryImages.flatMap(category => category.images)
        .map(image => this.galleryImageUrl(image)).filter(url => this.isTourImage(url));
      if (this.tourPhotoRibbonReady) {
        this.tour.notify('photos-ready');
        if (this.tourPhotoInteracted) this.tour.notify('photos-explored');
      }
      else if (!urls.length || urls.every(url => this.failedTourImages.has(this.tourImageKey(url)))) this.tour.notify('photos-unavailable');
    }
    if (this.tour.step === 'menu' && !this.menuLoading) {
      if (this.menuError) { this.tour.notify('menu-unavailable'); return; }
      const products = this.products.filter(product => this.isTourImage(product.productImageUrl) &&
        this.menuCategories.some(category => category.id === product.productCategoryId));
      if (products.some(product => product.productCategoryId === this.activeCategoryPanel && this.isTourImageReady(product.productImageUrl))) {
        this.tour.notify('menu-ready');
      } else if (!products.length || products.every(product => this.failedTourImages.has(this.tourImageKey(product.productImageUrl)))) {
        this.tour.notify('menu-unavailable');
      }
    }
  }

  private notifyTourLoadFailure(): void {
    this.tourDataLoaded = true;
    this.tourLoadFailed = true;
    this.loaderService.setLoading(false);
    if (this.tour.active) {
      this.tour.notify('photos-unavailable');
      this.tour.notify('menu-unavailable');
    }
  }

  public openWhatsApp = () => {
    const phoneNumber = environment.whatsAppInquiryNumber;
    const url = `https://wa.me/${phoneNumber}`;
    window.open(url, '_blank');
  }
}
